import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface PageContainerProps {
  children: ReactNode;
  /** Only for pages that genuinely need a narrow column (forms). */
  maxWidth?: string;
  /** Fill the viewport height (flex column) for app-like pages that scroll internally. */
  fill?: boolean;
  className?: string;
}

/**
 * The page's outer padding: tight on phones, DESIGN.md's `px-6 py-5` from `lg`.
 * AppShell wraps every page in one, so pages never add their own. Below `lg`
 * (no sidebar: phones and tablets) the shell also sets `--mobile-dock-height`
 * (0 when no softphone dock is shown) for anything pinned to the bottom edge.
 */
export function PageContainer({ children, maxWidth, fill = false, className }: PageContainerProps) {
  return (
    <div
      className={cn(
        'w-full min-w-0',
        fill
          ? 'flex min-h-0 flex-1 flex-col gap-3 px-3 py-3 sm:px-4 sm:py-4 lg:px-6 lg:py-5'
          : 'px-3 py-4 sm:px-4 sm:py-5 lg:px-6',
        maxWidth && 'mx-auto',
        className
      )}
      style={maxWidth ? { maxWidth } : undefined}
    >
      {children}
    </div>
  );
}
